import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
// Modules
import auth from './modules/auth';
import orderChange from './modules/order/change';
import locks from './modules/locks';
import orderReturn from './modules/order/return';
import forms from './modules/forms';

const store = {
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  actions,
  getters,
  modules: {
    order: orderChange,
    orderReturn,
    locks,
    forms,
    auth,
  },
};

Vue.use(Vuex);

export default new Vuex.Store(store);
